import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Box, FormControlLabel, IconButton, Stack, Switch, TextField, Tooltip } from "@mui/material";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import React from "react";

import { EnhancedCenterDialTime, EnhancedCenterDialTimeMinMax } from "../../../../Models/CenterDialTime";
import { DateTime } from "../../../../Types/DateTime";

interface DialTimeFormProps {
  dialTime: EnhancedCenterDialTime;
  disabled: boolean;
  minMaxTimes?: EnhancedCenterDialTimeMinMax;
  deleteDialTime: () => void;
  updateDialTime: (updatedDialTime: EnhancedCenterDialTime) => void;
}

const DialTimeForm: React.FC<DialTimeFormProps> = ({
  dialTime,
  disabled,
  minMaxTimes,
  deleteDialTime,
  updateDialTime
}) => {
  return (
    <Stack direction="row" spacing={1}>
      <Stack spacing={1}>
        <TimePicker
          value={dialTime.dialTimeDateTime}
          onChange={(newValue: DateTime | null) =>
            newValue &&
            updateDialTime({
              ...dialTime,
              dialTime: newValue.toISOTime({ includeOffset: false }),
              dialTimeDateTime: newValue
            })
          }
          disabled={disabled || Boolean(dialTime.id)}
          renderInput={params => <TextField {...params} />}
          minutesStep={15}
          minTime={minMaxTimes?.minimum}
          maxTime={minMaxTimes?.maximum}
          label="Dial Time"
        />
        <FormControlLabel
          sx={{ m: 0 }}
          control={<Switch />}
          disabled={disabled}
          checked={!dialTime.isDisabled}
          onChange={() => updateDialTime({ ...dialTime, isDisabled: !dialTime.isDisabled })}
          label="Enabled"
        />
      </Stack>
      <Box display="flex" alignContent="center">
        <Tooltip title={disabled ? "" : "Delete"}>
          <IconButton onClick={deleteDialTime} disabled={disabled}>
            <DeleteForeverIcon color={disabled ? "disabled" : "error"} />
          </IconButton>
        </Tooltip>
      </Box>
    </Stack>
  );
};

export default DialTimeForm;
